import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const offerApi = createApi({
  reducerPath: 'offerApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['offer'],
  endpoints: (builder) => ({
    getAllOfferDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.offerDetailController.getAllOfferDetail,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    saveOfferDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.offerDetailController.saveOfferDetail,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateOfferDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.offerDetailController.updateOfferDetail,
          method: 'PUT',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteOfferDetail: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.offerDetailController.deleteOfferDetail}${body.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    findOfferDetailById: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.offerDetailController.findOfferDetailById}${body.userId}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    uploadOfferImage: builder.mutation({
      query(body) {
        return {
          url: spotFinder.offerDetailController.uploadOfferImage,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});

export const {
  useDeleteOfferDetailMutation,
  useGetAllOfferDetailMutation,
  useFindOfferDetailByIdMutation,
  useSaveOfferDetailMutation,
  useUpdateOfferDetailMutation,
  useUploadOfferImageMutation,
} = offerApi;
